import axios from '@/lib/axios';
import { User } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2240. Slack連携設定登録
 * [POST] /workspaces/:identifier/slack_setting
 */
type Props = {
  identifier: string;
  code: string;
};
const createSlackSetting = (props: Props): Promise<User> => {
  return axios.post(`/api/workspaces/${props.identifier}/slack_setting`, props);
};

export const useCreateSlackSetting = () => {
  return useMutation({
    mutationFn: createSlackSetting,
  });
};
